import styled, {css} from "styled-components"

import {H2} from "@irati/ui/src/Typography/Heading"
import {Card} from "@irati/ui/src/Layout"

export const NAVIGATION_SIDEBAR_WIDTH = 227
export const COLLAPSED_SIDEBAR_WIDTH = 96
export const SECONDARY_NAV_COLLAPSED_SIDEBAR_WIDTH = 64

interface MainProps {
  marginTop?: boolean
  flush?: boolean
  mainBackground?: string
  withPadding?: boolean
  shouldDisplayNavigation?: boolean
  isAdminSection?: boolean
}

export const Main = styled.div<MainProps>`
  position: relative;
  z-index: 20;
  min-height: calc(100vh - 290px);
  padding-bottom: 100px;
  background: ${({theme}) => theme.colors.greys.lightest};
  ${({marginTop, theme}) => marginTop && `margin-top: ${theme.spacing.six};`}
  ${({flush}) => flush && "padding-bottom: 0;"}
  ${({mainBackground}) => mainBackground && `background: ${mainBackground};`}
  &.hidden-nav {
    height: 100%;
    min-height: 100%;
  }
  /* if sidebar is displayed, set Grid to fluid until xlDesktop resolution */
  .container {
    ${({theme, shouldDisplayNavigation, isAdminSection}) => css`
      ${shouldDisplayNavigation && isAdminSection && "width: 97.5%;"}
      ${shouldDisplayNavigation &&
      theme.mediaQueries.maxWidthMedia.extraLargeDesktop`
        width: 97.5%;
      `}
    `}
  }
`

export const StyledCard = styled(Card)`
  margin-top: 150px;
  text-align: center;
`

export const Picture = styled.img`
  box-shadow: ${({theme}) => theme.shadows.low};
  width: 100px;
  height: 100px;
  border: 2px solid ${({theme}) => theme.colors.greys.white};
  border-radius: 50%;
  background-color: #f1f1f1;
  margin: -80px auto 0;
  position: relative;
  overflow: hidden;
`
export const StyledH2 = styled(H2)`
  padding: 30px 15px;
`
